module.exports = __webpack_public_path__ + "static/media/profile-7.bcad3a3e.jpeg";